import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mallUrl } from '@/config';
export default {
  name: 'GoodsItem',
  props: {
    // goodsDetail: {goodsImg: '', goodsName: '', sellPrice: '', originPrice: '', goodsId: '' }
    goodsDetail: {
      type: Object,
      default: null
    }
  },
  methods: {
    // 跳转到商品详情页
    jump2Buy: function jump2Buy() {
      var jumpeUrl = "".concat(mallUrl, "/mmall/store/detail/").concat(this.goodsDetail.goodsId);
      if (window.__wxjs_environment === 'miniprogram') {
        this.goWithWx({
          wxPath: "/pages/mall/index?url=".concat(encodeURIComponent(jumpeUrl))
        });
      } else {
        this.Env.redirect(jumpeUrl);
      }
      window.seedAction({
        bid: 'b_movie_wyqr5ujk_mc',
        evt: 'click'
      });
    }
  }
};